/**
 * 随机生成域名和路径的工具函数
 */

// 可用的域名列表
const domains = [
  'vip1.4455kk.xyz',
  'vip2.4455kk.xyz',
  'vip3.4455kk.xyz',
  'vip4.4455kk.xyz',
  'vip5.4455kk.xyz',
  'vip6.4455kk.xyz',
  'vip7.4455kk.xyz'
];

/**
 * 生成随机字符串
 * @param {number} length - 字符串长度
 * @returns {string} 随机字符串
 */
export function generateRandomString(length = 20) {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

/**
 * 获取随机域名
 * @returns {string} 随机域名
 */
export function getRandomDomain() {
  const randomIndex = Math.floor(Math.random() * domains.length);
  return domains[randomIndex];
}

/**
 * 生成完整的随机URL
 * @returns {string} 随机完整URL
 */
export function generateRandomUrl() {
  const domain = getRandomDomain();
  const path = generateRandomString(20 + Math.floor(Math.random() * 10));
  return `https://${domain}/${path}`;
}

/**
 * 生成一个新的随机URL并重定向
 */
export function redirectToRandomUrl() {
  const newUrl = generateRandomUrl();
  window.location.href = newUrl;
} 